import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18 8V12.6472C18 12.8731 18.0897 13.0897 18.2495 13.2495L19.5858 14.5858C19.851 14.851 20 15.2107 20 15.5858C20 16.3668 19.3668 17 18.5858 17H5.41421C4.63317 17 4 16.3668 4 15.5858C4 15.2107 4.149 14.851 4.41421 14.5858L5.75052 13.2495C5.91026 13.0897 6 12.8731 6 12.6472V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 19V19C15 20.6569 13.6569 22 12 22V22C10.3431 22 9 20.6569 9 19V19",
		stroke: "currentColor",
		strokeWidth: 1.5
	})]
});
export default SvgBell;
